import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=logged
  useEffect(() => {
    let m = true;
    api.get("/auth/me")
      .then((r) => m && setUser(r.data.user))
      .catch(() => m && setUser(false));
    return () => { m = false; };
  }, []);
  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data.user);
    return r.data.user;
  };
  const refresh = async () => {
    try { const r = await api.get("/auth/me"); setUser(r.data.user); } catch { /* ignore */ }
  };
  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };
  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
